import React from 'react'
import Text from "../text/Text";
import './Toolbar.css';

function Toolbar({title, leftButton, rightButton}) {
    return (
        <div className="ToolbarRoot">
            {(() => {
                if (leftButton) return leftButton
                else return <div className="ToolbarFakeButton"/>
            })()}
            <Text style="ToolbarTitle" text={title}/>
            {(() => {
                if (rightButton) return rightButton
                else return <div className="ToolbarFakeButton"/>
            })()}
        </div>
    )
}

export default Toolbar;
